export default __webpack_public_path__ + "static/media/money-plants-and-watering-can-background.c6318e3e.svg";